/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { MibiStructReport } from '../models/mibi-struct-report';
import { PatientRecordBundle } from '../models/patient-record-bundle';
import { RecordDocumentDto } from '../models/record-document-dto';
import { recordDocuments } from '../fn/record/record-documents';
import { RecordDocuments$Params } from '../fn/record/record-documents';
import { recordGetRecordReference } from '../fn/record/record-get-record-reference';
import { RecordGetRecordReference$Params } from '../fn/record/record-get-record-reference';
import { recordIsOrderNumberAvailable } from '../fn/record/record-is-order-number-available';
import { RecordIsOrderNumberAvailable$Params } from '../fn/record/record-is-order-number-available';
import { recordRecordBundle } from '../fn/record/record-record-bundle';
import { RecordRecordBundle$Params } from '../fn/record/record-record-bundle';
import { RecordReferencesResponseDto } from '../models/record-references-response-dto';
import { recordStructMibi } from '../fn/record/record-struct-mibi';
import { RecordStructMibi$Params } from '../fn/record/record-struct-mibi';

@Injectable({ providedIn: 'root' })
export class RecordApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `recordStructMibi()` */
  static readonly RecordStructMibiPath = '/api/record/struct-mibi/{casID}';

  /**
   * Get record documents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recordStructMibi()` instead.
   *
   * This method doesn't expect any request body.
   */
  recordStructMibi$Response(params: RecordStructMibi$Params, context?: HttpContext): Observable<StrictHttpResponse<MibiStructReport>> {
    const obs = recordStructMibi(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get record documents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recordStructMibi$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recordStructMibi(params: RecordStructMibi$Params, context?: HttpContext): Observable<MibiStructReport> {
    const resp = this.recordStructMibi$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MibiStructReport>): MibiStructReport => r.body)
    );
  }

  /** Path part for operation `recordDocuments()` */
  static readonly RecordDocumentsPath = '/api/record/documents/{recID}';

  /**
   * Get record documents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recordDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  recordDocuments$Response(params: RecordDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RecordDocumentDto>>> {
    const obs = recordDocuments(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get record documents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recordDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recordDocuments(params: RecordDocuments$Params, context?: HttpContext): Observable<Array<RecordDocumentDto>> {
    const resp = this.recordDocuments$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<RecordDocumentDto>>): Array<RecordDocumentDto> => r.body)
    );
  }

  /** Path part for operation `recordRecordBundle()` */
  static readonly RecordRecordBundlePath = '/api/record/record-bundle/{recID}';

  /**
   * Get record bundle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recordRecordBundle()` instead.
   *
   * This method doesn't expect any request body.
   */
  recordRecordBundle$Response(params: RecordRecordBundle$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientRecordBundle>> {
    const obs = recordRecordBundle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get record bundle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recordRecordBundle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recordRecordBundle(params: RecordRecordBundle$Params, context?: HttpContext): Observable<PatientRecordBundle> {
    const resp = this.recordRecordBundle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PatientRecordBundle>): PatientRecordBundle => r.body)
    );
  }

  /** Path part for operation `recordIsOrderNumberAvailable()` */
  static readonly RecordIsOrderNumberAvailablePath = '/api/record/check-number/{recOrdID}/{prtID}';

  /**
   * Check order number available.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recordIsOrderNumberAvailable()` instead.
   *
   * This method doesn't expect any request body.
   */
  recordIsOrderNumberAvailable$Response(params: RecordIsOrderNumberAvailable$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = recordIsOrderNumberAvailable(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Check order number available.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recordIsOrderNumberAvailable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recordIsOrderNumberAvailable(params: RecordIsOrderNumberAvailable$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.recordIsOrderNumberAvailable$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `recordGetRecordReference()` */
  static readonly RecordGetRecordReferencePath = '/api/record/references/{recID}';

  /**
   * Get record references.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recordGetRecordReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  recordGetRecordReference$Response(params: RecordGetRecordReference$Params, context?: HttpContext): Observable<StrictHttpResponse<RecordReferencesResponseDto>> {
    const obs = recordGetRecordReference(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get record references.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recordGetRecordReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recordGetRecordReference(params: RecordGetRecordReference$Params, context?: HttpContext): Observable<RecordReferencesResponseDto> {
    const resp = this.recordGetRecordReference$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RecordReferencesResponseDto>): RecordReferencesResponseDto => r.body)
    );
  }

}
